import type { CatalogPickerItem } from './materialCatalogPickerTypes'

type TemplateLike = {
  id: string
  name: string
  featuredTemplate?: boolean | null
  slug?: string
  description?: string | null
  brand?: string | null
  model?: string | null
  category?: { id: string; name: string; slug?: string } | null
  images?: {
    edges?: Array<{
      node?: { contentUrl?: string | null } | null
    } | null> | null
  } | null
}

export function catalogItemFromTemplateLike(
  node: TemplateLike,
  placeholderImageUrl: string
): CatalogPickerItem {
  const imageUrl =
    node.images?.edges?.[0]?.node?.contentUrl?.trim() || placeholderImageUrl
  return {
    id: node.id,
    name: node.name,
    slug: node.slug,
    description: node.description,
    brand: node.brand,
    model: node.model,
    category: node.category,
    imageUrl,
    instanceManagementEnabled: undefined,
  }
}

type MyMaterialsCatalogNode = {
  id: string
  name: string
  slug?: string
  description?: string | null
  brand?: string | null
  model?: string | null
  instanceManagementEnabled?: boolean
  category?: { id: string; name: string; slug?: string } | null
  images?: {
    edges?: Array<{
      node?: { contentUrl?: string | null } | null
    } | null> | null
  } | null
}

export function catalogItemFromMyMaterialsNode(
  node: MyMaterialsCatalogNode,
  placeholderImageUrl: string
): CatalogPickerItem {
  const base = catalogItemFromTemplateLike(node, placeholderImageUrl)
  return {
    ...base,
    instanceManagementEnabled: node.instanceManagementEnabled,
  }
}
